import React from 'react';

const CarfaxCAIcon: React.FC = () => (
  <svg
    width="681"
    height="100"
    viewBox="0 0 681 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M187.632 1.19049H96.7686V96.0953H187.632V1.19049Z" fill="black" />
    <path d="M284.258 1.19049H193.395V96.0953H284.258V1.19049Z" fill="black" />
    <path d="M380.884 1.19049H290.021V96.0953H380.884V1.19049Z" fill="black" />
    <path d="M477.509 1.19049H386.646V96.0953H477.509V1.19049Z" fill="black" />
    <path d="M91.0066 1.19049H0.143066V96.0953H91.0066V1.19049Z" fill="black" />
    <path
      d="M47.6226 81.9524C28.7641 81.9524 18.7158 68 18.7158 49.2381C18.7158 28.8095 30.669 16.5238 47.6702 16.5238C63.2427 16.5238 69.4336 23.2381 73.7673 35.1905L57.8138 41.4762C55.5279 35.5714 53.3849 31.8571 47.575 31.8571C40.2411 31.8571 37.0504 39.2381 37.0504 49.2857C37.0504 59.3333 40.1459 66.7143 47.7655 66.7143C53.2897 66.7143 55.6232 63.7143 59.0996 57.7143L73.9578 65.619C69.7194 73.9524 62.6236 82 47.6226 82"
      fill="white"
    />
    <path
      d="M147.344 55.4762H136.819L138.01 51.3333C140.296 43.2857 141.296 39.7619 142.105 35.4762C142.915 39.7619 143.915 43.1905 146.201 51.3333L147.391 55.4762H147.344ZM174.06 80.6191L151.058 17.1905H133.295L110.293 80.6191H129.152L132.581 69.381H151.63L155.058 80.6191H174.107H174.06Z"
      fill="white"
    />
    <path
      d="M248.399 38.2381C248.399 42.7619 246.113 45.3334 240.398 45.3334H230.064V31.4286H240.684C246.208 31.4286 248.399 34.2381 248.399 38.2381ZM267.162 80.5239L254.447 56.3334C261.4 53.1905 265.876 47.2858 265.876 37.7619C265.876 22.7143 255.971 17.0953 241.112 17.0953H212.729V80.5239H230.016V59.0953H237.065L247.399 80.5239H267.067H267.162Z"
      fill="white"
    />
    <path
      d="M328.166 32.0477V40.9048H347.977V55.7619H328.166V80.5239H310.641V17.1429H360.835V32.0477H328.166Z"
      fill="white"
    />
    <path
      d="M437.364 55.4286H426.84L428.03 51.2857C430.316 43.2381 431.269 39.7143 432.126 35.4286C432.935 39.7143 433.935 43.0953 436.221 51.2857L437.412 55.4286H437.364ZM464.08 80.5715L441.079 17.1429H423.316L400.314 80.5715H419.172L422.601 69.381H441.65L445.079 80.5715H464.128H464.08Z"
      fill="white"
    />
    <path
      d="M528.704 79.8096C527.132 83.1429 524.132 86.3334 521.561 90.2857L520.751 91.381H535.657L534.942 90.2857C532.466 86.3334 530.371 83.2381 528.704 79.8096Z"
      fill="white"
    />
    <path
      d="M517.798 66.8095L495.892 35.6191H518.179L522.037 41.7619C524.513 45.7143 527.18 49.9524 528.656 53.2857C530.228 49.9524 532.942 45.7143 535.419 41.7619L539.276 35.6191H561.087L539.181 66.4286L557.468 91.381H569.421V5.7619L487.987 5.85714V91.381H499.226L517.751 66.8095H517.798Z"
      fill="white"
    />
    <path
      d="M483.272 1.19049V96.0953H574.135V1.19049H483.272ZM520.751 91.4286L521.56 90.3334C524.132 86.381 527.132 83.1905 528.704 79.8571C530.37 83.2857 532.466 86.381 534.942 90.3334L535.657 91.4286H520.751ZM569.421 91.4286H557.515L539.228 66.4762L561.135 35.6667H539.323L535.466 41.8095C532.99 45.7619 530.323 50 528.704 53.3333C527.227 50 524.561 45.7619 522.084 41.8095L518.227 35.6667H495.892L517.798 66.8572L499.273 91.4286H488.034V5.90478L569.468 5.80954V91.4286H569.421Z"
      fill="black"
    />
    <path
      d="M628.187 96.1429H634.949V96V84.8572L657.856 87.4286L656.76 77.9524L680.667 60.1429L675.857 53.5714L680.667 38.381L665.237 39.8095L661.237 32.3334L646.331 46.381L651.665 15.2381L641.759 21.1429L631.616 1.19049L631.568 1.14288L621.425 21.0476L611.519 15.1905L616.853 46.3334L601.995 32.2857L597.947 39.7619L582.517 38.2857L587.327 53.5238L582.517 60.0476L606.471 77.9048L605.328 87.381L628.187 84.8095V96.1429Z"
      fill="#EB1C2D"
    />
  </svg>
);

export default CarfaxCAIcon;
